import React, { ReactNode, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ErrorScreen from "components/ErrorScreen";
import { ShellBridgeEvents } from "app/shared/constants/constants";
import { publishShellEvent, publishTopBarUpdate } from "utilities/publishBridgeEvent";
import useIsOnline from "hooks/useIsOnline";
import T_ROUTES from "routes/routePaths";
import { useDispatch } from "react-redux";
import { resetTOrder } from "store/slices/tOrderSlice";
import { toggleCartDrawer, toggleUpsellModal } from "app/store/slices/authSlice";

type ShellNetworkStatusGuardProps = {
    children: ReactNode;
};

export default function ShellNetworkStatusGuard({ children }: ShellNetworkStatusGuardProps) {
    const isOnline = useIsOnline();
    const navigate = useNavigate();
    const wasOffline = useRef(!isOnline);
    const dispatch = useDispatch();
    useEffect(() => {
        if (isOnline && wasOffline.current) {
            dispatch(resetTOrder());
            dispatch(toggleCartDrawer(false));
            dispatch(toggleUpsellModal(false));
            navigate(T_ROUTES.CATEGORY, { replace: true });
        }

        wasOffline.current = !isOnline;
    }, [isOnline, navigate, dispatch]);

    if (!isOnline) {
        publishTopBarUpdate({
            title: 'Offline',
            showBackButton: false,
        });
        return (
            <ErrorScreen
                title="No Internet Connection"
                description="We couldn't complete your order because your internet connection was interrupted. Please check your connection and try again."
                primaryActionLabel="Back to Home"
                primaryAction={() => publishShellEvent(
                    ShellBridgeEvents.MOBILE_ORDERCON_POPHOME,
                )}
            />
        );
    }

    return children;
}
